<template>
  <div class="hero">
    <div class="hero-container">
        <h1>High Altitude<br /><span class="highlight">Design.</span></h1>
      <img src="@/assets/splash.png">
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainHero',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.hero {
  .hero-container {
    position: relative;
    overflow: hidden;
    h1 {
      position: absolute;
      left: 35px;
      top: 5%;
      font-family: 'Electrolize', sans-serif;
      color: white;
      text-transform: uppercase;
      text-align: left;
      .highlight {
        background: linear-gradient(90deg, rgba(241,136,255,1) 0%, rgba(161,92,187,1) 100%);
        padding: 1px 8px 0px 4px;
      }
    }
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 875px) {
  .hero {
    .hero-container {
    h1{text-align: center;
    
    }
      img {
        width: 120%;
        margin-top: 50px;
      }
    }
  }
}
@media screen and (max-width: 670px) {
  .hero {
    .hero-container {
    
    h1{text-align: center;
    }
    
      img {
        width: 135%;
        margin-top: 50px;
      }
    }
  }
}

@media screen and (max-width: 550px) {
  .hero {
    .hero-container {
      img {
        width: 200%;
        margin-top: 225px;
        margin-left: -50%;
      }
    }
  }
}

</style>
